import script from "./ArticlesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesPage.vue?vue&type=script&setup=true&lang=js"

import "./ArticlesPage.vue?vue&type=style&index=0&id=63e18f5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e18f5f"]])

export default __exports__